import {IFilter} from '@toolify/server/src/services/FilterService/types/IFilter'
import {FilterItemType} from '@toolify/server/src/services/FilterService/enum/FilterItemType'
import {FilterPropertyOperator} from '@toolify/server/src/services/FilterService/enum/FilterPropertyOperator'
import {FilterPropertyPayloadType} from '@toolify/server/src/services/FilterService/enum/FilterPropertyPayloadType'
import {FilterGroupOperator} from '@toolify/server/src/services/FilterService/enum/FilterGroupOperator'
import {IFilterPropertyItem} from '@toolify/server/src/services/FilterService/types/IFilterPropertyItem'
import {
  IDatabaseGroupItemResponseInstance,
} from '@toolify/server/src/controllers/DatabaseItemController/validators/GetGroups/types/IDatabaseGroupItemResponseInstance'
import {
  IDatabasePropertyResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IDatabasePropertyResponseInstance'
import {StatusGroupType} from '@toolify/server/src/models/mongoose/StatusModel/enum/StatusGroupType'
import {
  isStatusGroupBucket,
} from '@toolify/server/src/services/DatabasePropertyService/strategies/ColumnTypeStrategies/StatusPropertyTypeStrategy/statusGroupBucketing'
import {IGroupGranularityDescriptor} from '@toolify/client/src/modules/databases/utils/groupSortModes'
import {
  useValueTypeStrategy,
} from '@toolify/client/src/modules/databases/strategies/PropertyValueTypeStrategy/composables/useValueTypeStrategy'

export function useStatusPropertyTypeStrategy() {
  const getGroupGranularityDescriptor = (property: IDatabasePropertyResponseInstance): IGroupGranularityDescriptor | null => {
    return useValueTypeStrategy(property.valueType).groupGranularity ?? null
  }

  const buildStatusFilterItem = (group: string, operator: FilterPropertyOperator, value: string[] | null): IFilterPropertyItem => ({
    type: FilterItemType.Property,
    id: group,
    subProperty: null,
    operator: {
      type: operator,
    },
    payload: {
      type: FilterPropertyPayloadType.Static,
      value,
    },
    isDisabled: false,
  })

  const getGroupFilter = (group: string, groupItem: IDatabaseGroupItemResponseInstance, _showAllDatabaseGroups: boolean): IFilter => {
    const value = groupItem?.value ?? null
    if(!isStatusGroupBucket(value)) {
      return null
    }
    if(value.groupType === StatusGroupType.Other && Array.isArray(value.excludedStatusIds)) {
      return {
        type: FilterItemType.Group,
        operator: FilterGroupOperator.And,
        items: [
          buildStatusFilterItem(group, FilterPropertyOperator.NotEmpty, null),
          buildStatusFilterItem(group, FilterPropertyOperator.NotIn, value.excludedStatusIds),
        ],
      }
    }
    return buildStatusFilterItem(group, FilterPropertyOperator.In, value.statusIds)
  }

  return {
    getGroupFilter,
    getGroupGranularityDescriptor,
  }
}
